/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const CREATE_USER_PROFILE_IMAGE = gql`
  mutation CreateUserProfileImage($data: CreateUserProfileImageInput!) {
    createUserProfileImage(data: $data) {
      url
    }
  }
`
